import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../../constants/constants';

export const componentKey = "SUBMIT_FORM_FOR_MULTIPLE_PAYERS";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },

        setScheduleDate: (state, action) => {
            state.scheduleDate = action.payload
        },

        setPaginationState: (state, action) => {
            state.paginationState = { ...state.paginationState, ...action.payload }
        },

        setSelectedPayer: (state, action) => {
            state.selectedPayer = action.payload
        },

        setIsCheckBoxChecked: (state, action) => {
            const { name, index, checked } = action.payload
            state.payerPaymentList[index][name] = checked
        },

        setIsAllCheckBoxChecked: (state, action) => {
            const { name, checked } = action.payload
            state.payerPaymentList.map(form => form[name] = checked)
        },

        setPayerPaymentList: (state, action) => {
            state.payerPaymentList = action.payload
        },

        setPayersPaymentDetails: (state, action) => {
            state.payersPaymentDetails = action.payload
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        scheduleDate: "",
        selectedPayer: [],
        payerPaymentList: [],
        payersPaymentDetails: {},

        paginationState: {
            PageNumber: 1,
            PageSize: 20,
            FilterText: "",
            IsDesc: true,
            IdNumber: "",
            Skip: 0,
            totalPayer: 10,
        },
    }
})

export const { setLoadingState, setScheduleDate, setPaginationState, setSelectedPayer, setIsCheckBoxChecked, setIsAllCheckBoxChecked, setPayerPaymentList, setPayersPaymentDetails } = actions; 